import { render, staticRenderFns } from "./MoviesSearch.vue?vue&type=template&id=a2477b0a&"
import script from "./MoviesSearch.vue?vue&type=script&lang=js&"
export * from "./MoviesSearch.vue?vue&type=script&lang=js&"
import style0 from "./MoviesSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports